import React, { ReactElement, Dispatch, SetStateAction } from 'react';

import Modal from '~/components/Modal';
import Link from '~/components/flow/Link';
import COLORS from '~/constants/colors';

interface DisplayProps {
  result: File | undefined;
  setResult: Dispatch<SetStateAction<File | undefined>>;
}

function Display({ result, setResult }: DisplayProps): ReactElement {
  const hider = () => setResult(undefined);
  const src = result && URL.createObjectURL(result);

  // Rendering
  const title = 'Click to download!';
  const alt = 'Your image encoded with identifying message';

  // Styling
  const imgStyle = {
    width: '100%',
    borderRadius: '0.5em',
  };
  const closeStyle = {
    position: 'absolute' as const,
    top: '0.9em',
    right: '0.9em',
    width: '1.5em',
    height: '1.5em',
    textAlign: 'center' as const,
    cursor: 'pointer',
  };
  const fSlashStyle = {
    display: 'inline-block',
    height: '1.5em',
    width: '0.3em',
    backgroundColor: COLORS.silver,
    transform: 'rotate(45deg)',
  };
  const bSlashStyle = {
    ...fSlashStyle,
    transform: 'rotate(90deg)',
  };

  return (
    <Modal visible={!!result} title={title} hider={hider}>
      <div
        role="button"
        tabIndex={0}
        onMouseUp={hider}
        onTouchEnd={hider}
        style={closeStyle}
      >
        <div style={fSlashStyle}>
          <div style={bSlashStyle} />
        </div>
      </div>
      <Link href={src} download={result?.name}>
        <img src={src} alt={alt} style={imgStyle} />
      </Link>
    </Modal>
  );
}

export default Display;
